module.exports = __webpack_public_path__ + "img/TotalEnergies_120X35.5e331de8.png";